import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import AppPage from '../common/AppPage';
import SkillInfoModal from './SkillInfoModal';
import SkillList from './SkillList';
import SkillLoadModal from './SkillLoadModal';
import SkillPracModal from './SkillPracModal';
import SkillSaveModal from './SkillSaveModal';
import SkillShareModal from './SkillShareModal';
import { decodeBuild } from './skillShareSlice';
import SkillTrainerFooter from './SkillTrainerFooter';
import SkillTrainerHeader from './SkillTrainerHeader';
import { getTrainerResults } from './skillTrainerSlice';

function SkillTrainerPage() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  
  useEffect(() => {
    if (code) {
      dispatch(decodeBuild(code));
      dispatch(getTrainerResults());
      //window.history.replaceState(null, '', window.location.pathname);
    }
  }, [dispatch, code]);

  return (
    <AppPage pageClass="skill-trainer-page">
      <div className="skill-trainer">
        <h5>WoTMud Skill Trainer</h5>
        <SkillTrainerHeader />
        <SkillList />
        <SkillTrainerFooter />
        <SkillPracModal />
        <SkillInfoModal />
        <SkillLoadModal />
        <SkillSaveModal />
        <SkillShareModal />
      </div>
    </AppPage>
  );
}

export default SkillTrainerPage;